import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from '@quorum/models/xs-resource';

@Pipe({
  name: 'sortNamesBy',
})
export class SortNamesByPipe implements PipeTransform {
  transform(array: Employee[], args: string[]): any[] {
    if (args[0] === 'firstName') {
      array.sort((a: Employee, b: Employee) => {
        if (a.embedded.associate.firstName == null) {
          if (b.embedded.associate.firstName == null) {
            return a.embedded.associate.lastName?.localeCompare(b.embedded.associate.lastName);
          }
          return a.embedded.associate.lastName?.localeCompare(b.embedded.associate.firstName);
        }
        if (b.embedded.associate.firstName == null) {
          return a.embedded.associate.firstName?.localeCompare(b.embedded.associate.lastName);
        }
        if (!a.embedded.associate.firstName?.localeCompare(b.embedded.associate.firstName)) {
          return a.embedded.associate.lastName?.localeCompare(b.embedded.associate.lastName);
        }
        return a.embedded.associate.firstName?.localeCompare(b.embedded.associate.firstName);
      });
    } else {
      array.sort((a: Employee, b: Employee) => {
        if (a.embedded.associate.lastName == null) {
          if (b.embedded.associate.lastName == null) {
            return a.embedded.associate.firstName?.localeCompare(b.embedded.associate.firstName);
          }
          return a.embedded.associate.firstName?.localeCompare(b.embedded.associate.lastName);
        }
        if (b.embedded.associate.lastName == null) {
          return a.embedded.associate.lastName?.localeCompare(b.embedded.associate.firstName);
        }
        if (!a.embedded.associate.lastName?.localeCompare(b.embedded.associate.lastName)) {
          return a.embedded.associate.firstName?.localeCompare(b.embedded.associate.firstName);
        }
        return a.embedded.associate.lastName?.localeCompare(b.embedded.associate.lastName);
      });
    }

    return array;
  }
}
